// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--JYj4t"};